import baseSpacingScale from './base-spacing-scale';

const radii = baseSpacingScale;

export { radii as default };
